module.exports = __webpack_public_path__ + "assets/img/prize-bg.e4efa632.png";